const DataEmpty = () => {
    return <div>
        <img src={`${process.env.PUBLIC_URL}/assets/images/common/data-empty.png`} className="w-full" alt="暂无数据" />
    </div>
}

export default DataEmpty;